import _ from 'lodash'
import {Mutation, MutationTree} from 'vuex'
import {GalleryState} from '@/modules/cms/modules/gallery/store/index'
import Gallery from '@/modules/cms/modules/gallery/model/Gallery';
import GalleryItem from '@/modules/cms/modules/gallery/model/GalleryItem';

export enum MutationTypes {
    SetGalleryList = 'SET_GALLERY_LIST',
    SetCurrentGallery = 'SET_CURRENT_GALLERY',
    SetCurrentGalleryItem = 'SET_CURRENT_GALLERY_ITEM',
    UpdateCurrentGalleryField = 'UPDATE_CURRENT_GALLERY_FIELD',
    UpdateCurrentGalleryItemField = 'UPDATE_CURRENT_GALLERY_ITEM_FIELD',
    AddGalleryItem = 'ADD_GALLERY_ITEM',
    DeleteGalleryItem = 'DELETE_GALLERY_ITEM',
    ResetGallery = 'RESET_GALLEY',
    DeleteGallery = 'REMOVE_GALLERY',
    ToggleGalleryListFetched = 'TOGGLE_GALLERY_LIST_FETCH',
    AddGallery = 'ADD_GALLERY',
}

const mutations: MutationTree<GalleryState> = {
    /**
     * Establece la galería actual
     *
     * @param state
     * @param gallery
     */
    [MutationTypes.SetCurrentGallery]: (state, gallery: Gallery) => state.currentGallery = gallery,

    /**
     * Establece la galería actualmente en edición por el usuario
     *
     * @param state
     * @param gallery
     */
    [MutationTypes.SetGalleryList]: (state, list: Gallery[]) => state.galleryList = list,

    /**
     * Establece el elemento de la galería actualmente en edición
     *
     * @param state
     * @param item
     */
    [MutationTypes.SetCurrentGalleryItem]: (state, item: GalleryItem) => state.currentGalleryItem = item,

    /**
     * Actualiza un campo de la galería actualmente en edición
     *
     * @param state
     * @param payload
     */
    [MutationTypes.UpdateCurrentGalleryField]: (state, payload: { field: string, value: any }) => {
        _.set(state.currentGallery, payload.field, payload.value)
    },

    /**
     * Añade un nuevo elemento a la galería
     *
     * @param state
     * @param item
     */
    [MutationTypes.AddGalleryItem]: (state, item: GalleryItem) => state.currentGallery.items.push(item),

    /**
     * Actualiza un campo del item de galería actualmente en edición
     *
     * @param state
     * @param payload
     */
    [MutationTypes.UpdateCurrentGalleryItemField]: (state, payload: { field: string, value: any }) => {
        _.set(state.currentGalleryItem, payload.field, payload.value)
    },

    /**
     * Borra un elemento de la galería actualmente seleccionada
     *
     * @param state
     * @param tempId
     */
    [MutationTypes.DeleteGalleryItem]: (state, tempId: string) => {
        const index = state.currentGallery.items.findIndex(i => i.tempId === tempId)
        if (index === -1) {
            return
        }

        state.currentGallery.items.splice(index, 1)
    },

    [MutationTypes.ResetGallery]: (state) => state.currentGallery = new Gallery(),
    /**
     * Elimina una galería de la lista actualmente cargada de galerías
     *
     * @param state
     * @param id
     */
    [MutationTypes.DeleteGallery]: (state, id: null) => {
        const index = state.galleryList.findIndex(g => g.id === id)
        return index !== -1 && state.galleryList.splice(index, 1)
    },

    /**
     * @param state
     * @param fetched
     */
    [MutationTypes.ToggleGalleryListFetched]: (state, fetched: boolean) => {
        state.galleryListFetched = fetched
    },
    /**
     * Añade un galería a la lista de galerías actualmente cargada.
     *
     * @param state
     * @param gallery
     */
    [MutationTypes.AddGallery]: (state, gallery: Gallery) => {
        const index = state.galleryList.findIndex(g => g.id === gallery.id)
        index === -1 ? state.galleryList.push(gallery) : state.galleryList.splice(index, 1, gallery)
    },
}


export default mutations
